import './remove'
import './selected-options'
import './custom-event-for-ie-9-11'